import React from "react";
import {css} from "@emotion/react";

import {flexAlignCenter, mb, mv, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {concatWithBrandName} from "../../app/utils/concat_with_brand_name";
import {RegisterCompanyButton} from "./RegisterCompanyButton";

const contractorHero = require("../images/contractor_hero.svg");

export const ContractorHeader = () => {
    return (
        <section css={contractorHeader}>
            <div css={container}>
                <Text align="center" as="h1" color="#fff" fontFamily="secondary" variant="headline_1">
                    {concatWithBrandName("Pomóż naszym użytkownikom urządzić mieszkanie! Zostań partnerem portalu", ".")}
                </Text>

                <Text align="center" css={mv(5)} color="#fff">
                    Jesteśmy największym portalem nieruchomości deweloperskich w Polsce, który wg badań PBS odpowiada za sprzedaż ok. 40% lokali oferowanych na
                    rynku pierwotnym. Co miesiąc z naszych usług korzysta ok. 400 000 osób, które chcą kupić, a następnie urządzić mieszkanie, a także ok. 1000
                    deweloperów, promujących prawie 70 000 mieszkań i domów.
                </Text>

                <RegisterCompanyButton />

                <img css={hero} src={contractorHero} alt="hero" />
            </div>
        </section>
    );
};

const contractorHeader = css`
    ${p(5, 2, 0)};
    ${mb(10)};
    background-image: linear-gradient(180deg, #5549f6 0%, #6e92ee 100%);
`;

const container = css`
    max-width: 76.8rem;
    margin: 0 auto;
    ${flexAlignCenter};
    flex-direction: column;
`;

const hero = css`
    max-width: 35.4rem;
    position: relative;
    bottom: -6.6rem;
`;
import React from "react";
import {css} from "@emotion/react";

import {flexAlignCenter, mb, mv, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {concatWithBrandName} from "../../app/utils/concat_with_brand_name";
import {RegisterCompanyButton} from "./RegisterCompanyButton";

const contractorHero = require("../images/contractor_hero.svg");

export const ContractorHeader = () => {
    return (
        <section css={contractorHeader}>
            <div css={container}>
                <Text align="center" as="h1" color="#fff" fontFamily="secondary" variant="headline_1">
                    {concatWithBrandName("Pomóż naszym użytkownikom urządzić mieszkanie! Zostań partnerem portalu", ".")}
                </Text>

                <Text align="center" css={mv(5)} color="#fff">
                    Jesteśmy największym portalem nieruchomości deweloperskich w Polsce, który wg badań PBS odpowiada za sprzedaż ok. 40% lokali oferowanych na
                    rynku pierwotnym. Co miesiąc z naszych usług korzysta ok. 400 000 osób, które chcą kupić, a następnie urządzić mieszkanie, a także ok. 1000
                    deweloperów, promujących prawie 70 000 mieszkań i domów.
                </Text>

                <RegisterCompanyButton />

                <img css={hero} src={contractorHero} alt="hero" />
            </div>
        </section>
    );
};

const contractorHeader = css`
    ${p(5, 2, 0)};
    ${mb(10)};
    background-image: linear-gradient(180deg, #5549f6 0%, #6e92ee 100%);
`;

const container = css`
    max-width: 76.8rem;
    margin: 0 auto;
    ${flexAlignCenter};
    flex-direction: column;
`;

const hero = css`
    max-width: 35.4rem;
    position: relative;
    bottom: -6.6rem;
`;
